

export interface IExpandableSwaps {
    clusterNumber: number,
    chainId: number,
    isExpandable: boolean

}
